/**
 * Placeholder "Max" plan marketing copy for the upsell sheet. All strings are
 * placeholders pending final product copy.
 */
export const upsellEn = {
  'cancel-any-time': 'Cancel any time',
  description:
    'One plan with every tool your restaurant needs to grow and keep guests coming back.',
  'feature-cards': {
    app: {
      body: 'Average restaurant sees 2x more reorders from app users.',
      title: 'Branded mobile app',
    },
    reviews: {
      body: 'Owner automatically asks happy guests to leave reviews averaging 4.92 stars.',
      title: '5-star reviews',
    },
    sms: {
      body: 'Keep guests coming back with automated marketing campaigns.',
      title: 'Automated SMS marketing',
    },
  },
  'plan-boost': 'Boost',
  'plan-max': 'Max',
  price: '$199',
  'price-cadence': '/mo',
  'table-caption': 'See all the features included with Max:',
  'table-rows': {
    'ai-cro': 'AI-driven conversion rate optimization',
    'auto-email': 'Automated email marketing',
    'auto-gbp': 'Auto Google Business profile posts',
    'auto-sms': 'Automated SMS marketing',
    'branded-app': 'Custom-branded mobile app',
    'branded-email': 'Branded restaurant email',
    'branded-gift-cards': 'Branded gift cards',
    'catering-forms': 'Catering and events forms',
    'cross-channel-loyalty': 'Cross-channel loyalty program',
    'custom-email': 'Customizable email marketing',
    'custom-website': 'Custom branded website',
    'delivery-support': 'Customer support for deliveries',
    'job-board': 'Website job board',
    listings: 'Online listings management on 77+ sites',
    'live-tracking': 'Live order tracking',
    'loyalty-integrations': 'Loyalty & gift card integrations',
    'online-ordering': 'Online ordering',
    'order-with-google': 'Order with Google integration',
    promotions: 'Easy-to-use promotion tools',
    'push-marketing': 'Push notification marketing',
    reputation: 'Reputation management',
    reservations: 'Reservations embed support',
    'review-engine': 'Automated Google review engine',
    'review-replies': 'Online review replies',
    seo: 'Search Engine Optimization (SEO)',
    'unified-inbox': 'Unified inbox for customer comms',
    upscaling: 'Photo upscaling & improvements',
    'website-improver': 'Website improver',
  },
  'table-sections': {
    ai: 'AI features',
    brand: 'Brand customization',
    marketing: 'Marketing',
    ordering: 'Ordering & delivery',
    website: 'Website',
  },
  title: 'More orders. More reviews. More repeat guests.',
  'upgrade-cta': 'Upgrade to Max',
}
